import React  from 'react';
import Modal from 'react-modal';

// images
import loadingGIF from '../../inlineImages/loadingGIF';

// style
import './LoadingSpinner.css';

import PropTypes from 'prop-types';

const LoadingSpinner = ({ isModalOpen }) => {

    // if (isModalOpen) {
    //     document.body.style.overflow = 'hidden';
    // } else {
    //     document.body.style.overflow = 'initial';
    // }

    return (
        <Modal
            isOpen={isModalOpen}
            contentLabel="Loading Spinner"
            className="loading-spinner-wrapper"
        >
            <img src={loadingGIF} alt="loading-mugics"/>

        </Modal>
    )
};

LoadingSpinner.propTypes = {
    isModalOpen: PropTypes.bool
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/Components/Modals/LoadingSpinner/LoadingSpinner.js